var _rect, _path, _line, _line2, _line3, _line4, _line5, _path2, _line6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90 127.5C110.711 127.5 127.5 110.711 127.5 90C127.5 69.2893 110.711 52.5 90 52.5C69.2893 52.5 52.5 69.2893 52.5 90C52.5 110.711 69.2893 127.5 90 127.5ZM110.708 80.7691C111.823 79.6878 111.85 77.9072 110.769 76.7921C109.688 75.677 107.907 75.6496 106.792 76.7309L85.5469 97.3323L76.9579 89.0036C75.8428 87.9223 74.0622 87.9497 72.9809 89.0648C71.8996 90.1799 71.927 91.9605 73.0421 93.0418L83.589 103.269C84.6799 104.327 86.4139 104.327 87.5048 103.269L110.708 80.7691Z",
    fill: "url(#paint0_linear_302_31651)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 126.173,
    y1: 57.1769,
    x2: 149.177,
    y2: 36.8272,
    stroke: "#73DAB4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 56.6413,
    y1: 16.0116,
    x2: 68.3433,
    y2: 42.2397,
    stroke: "#C8C0FB",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 11.8014,
    y1: 97.8194,
    x2: 28.8194,
    y2: 96.1986,
    stroke: "#73DAB4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 42.535,
    y1: 154.21,
    x2: 50.2101,
    y2: 143.465,
    stroke: "#C8C0FB",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 123.535,
    y1: 43.2101,
    x2: 136.21,
    y2: 25.465,
    stroke: "#FFE1D3",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.312 120L160.312 131",
    stroke: "#C8C0FB",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 125.795,
    y1: 139.435,
    x2: 142.435,
    y2: 162.205,
    stroke: "#73DAB4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 52,
    r: 4,
    fill: "#C8C0FB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 54,
    r: 4,
    fill: "#C8C0FB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 161.5,
    r: 2.5,
    fill: "#C8C0FB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 148,
    r: 4,
    fill: "#79D8C8"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.5,
    cy: 98.5,
    r: 2.5,
    fill: "#EDEDED"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.5,
    cy: 155.5,
    r: 2.5,
    fill: "#EDEDED"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 106.5,
    r: 2.5,
    fill: "#EDEDED"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 55.5,
    r: 2.5,
    fill: "#EDEDED"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.5,
    cy: 137.5,
    r: 2.5,
    fill: "#FFE1D3"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.5,
    cy: 83.5,
    r: 2.5,
    fill: "#FFE1D3"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 20.5,
    r: 2.5,
    fill: "#FFE1D3"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 129.5,
    r: 2.5,
    fill: "#FFE1D3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_302_31651",
    x1: 31.1585,
    y1: 52.5,
    x2: 154.706,
    y2: 63.2563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EE036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccess);
export default __webpack_public_path__ + "static/media/payment-success.3e49af8cc715b90f514507e153bef082.svg";
export { ForwardRef as ReactComponent };